module.exports = __webpack_public_path__ + "img/Section.79a382d8.png";